<template>
    <div class="module">

      <Control :card="false" :icon="'mdi mdi-format-list-numbered'" :title="'Форма 200.00'">
        <div class="form-inline float-right">
          <SelectOrg class="mr-sm-1"  :name="'orgs'" :table="'reg_organizations'"
                     :fields="['name']"></SelectOrg>
          <Enums class=" mr-sm-1" :type="'enum'" :name="'quarters'" v-model="form.quarter"></Enums>
          <Enums class="mr-sm-1" :type="'enum'" :name="'years'" v-model="form.year"></Enums>
          <b-button class="mr-sm-1" size="sm" variant="primary" @click="getDataForm200()">Сформировать отчет
          </b-button>
          <download-excel v-if="typeof form.data.form_200_02 != 'undefined'" class="btn btn-sm btn-secondary mr-sm-1" :data="form.data.form_200_02.rows" :fields="excel.pril2.fields" worksheet="Приложение 2" name="Приложение 2.xls"><span class="mdi mdi-file-excel"></span> Прил. 2 в Excel</download-excel>
          <download-excel v-if="typeof form.data.form_200_05 != 'undefined'" class="btn btn-sm btn-secondary" :data="form.data.form_200_05.rows" :fields="excel.pril5.fields" worksheet="Приложение 5" name="Приложение 5.xls"><span class="mdi mdi-file-excel"></span> Прил. 5 в Excel</download-excel>

          <a @click="this.clearLink" class="btn btn-sm btn-success ml-sm-2" download v-if="this.link !== ''"
             :href="this.link">Скачать XML файл</a>
        </div>
      </Control>
        <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
            <div class="row">
                <div class="col-md-12">

                    <b-card no-body class="shadow-sm mb-1">
                        <b-tabs nav-wrapper-class="bg-secondary" pills card content-class="mt-0">
                            <b-tab title="Основная форма" active>
                                <div class="tax-form">
                                    <h4>Декларация по индивидуальному подоходному налогу и социальному налогу</h4>
                                    <div class="tax-form-section" v-if="typeof form.data.page_200_00_01 != 'undefined'">
                                        <h5>Общая информация о налогоплательщике</h5>

                                        <div class="row">
                                            <div class="col-md-4">1. ИИН (БИН)</div>
                                            <div class="col-md-8">
                                                <b-form-group>
                                                    <b-form-input readonly size="sm" v-model="form.data.page_200_00_01.iin"
                                                                  v-if="typeof form.data.page_200_00_01.iin != 'undefined'"></b-form-input>
                                                    <b-form-input readonly size="sm" v-model="form.data.page_200_00_01.bin"
                                                                  v-if="typeof form.data.page_200_00_01.bin != 'undefined'"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">2. Налоговый период</div>
                                            <div class="col-md-8">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <b-form-group>
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.period_quarter"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <b-form-group>
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.period_year"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">3. Наименование налогоплательщика</div>
                                            <div class="col-md-8">
                                                <b-form-group>
                                                    <b-form-input readonly size="sm"
                                                                  v-model="form.data.page_200_00_01.payer_name1"></b-form-input>
                                                </b-form-group>

                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">8. Общая численность работников</div>

                                            <div class="col-md-4">Всего</div>
                                            <div class="col-md-8">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <b-form-group label="1 месяц">
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_1"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                    <div class="col-md-4">
                                                        <b-form-group label="2 месяц">
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_2"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                    <div class="col-md-4">
                                                        <b-form-group label="3 месяц">
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_3"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">В том числе иностранцев и лиц без гражданства</div>
                                            <div class="col-md-8">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <b-form-group>
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_not_res_1"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                    <div class="col-md-4">
                                                        <b-form-group>
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_not_res_2"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                    <div class="col-md-4">
                                                        <b-form-group>
                                                            <b-form-input readonly type="number" size="sm"
                                                                          v-model="form.data.page_200_00_01.empl_not_res_3"></b-form-input>
                                                        </b-form-group>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr>
                                        <h5>Расчетные показатели</h5>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.001</b-badge>
                                                Сумма индивидуального подоходного налога, подлежащего уплате в бюджет
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_001_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_001_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_001_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_001_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.002</b-badge>
                                                Сумма обязательных пенсионных взносов, подлежащих перечислению
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_002_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_002_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_002_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_01.field_200_00_002_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.003</b-badge>
                                                Сумма обязательных профессиональных пенсионных взносов, подлежащих
                                                перечислению за
                                                работников
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_003_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_003_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_003_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_003_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.004</b-badge>
                                                Сумма обязательных пенсионных взносов работодателя
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_004_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_004_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_004_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_004_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.005</b-badge>
                                                Сумма обязательных пенсионных взносов, подлежащих перечислению в свою пользу
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_005_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_005_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_005_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_005_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.006</b-badge>
                                                Сумма социального налога, подлежащего уплате в бюджет с применением ставок,
                                                установленных пунктом 1 статьи 485 Налогового кодекса
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_006_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_006_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_006_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_006_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.007</b-badge>
                                                Сумма социального налога с учетом особенности, установленной статьей 700
                                                Налогового
                                                кодекса
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_007_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_007_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_007_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_007_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.008</b-badge>
                                                Сумма социального налога, подлежащего уплате в бюджет с применением ставок,
                                                установленных пунктом 2 статьи 485 Налогового кодекса
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_008_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_008_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_008_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_008_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.009</b-badge>
                                                Сумма социальных отчислений с доходов работников
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_009_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_009_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_009_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_02.field_200_00_009_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.010</b-badge>
                                                Сумма социальных отчислений в свою пользу
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_010_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_010_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_010_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_010_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.011</b-badge>
                                                Сумма отчислений на обязательное социальное медицинское страхование
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_011_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_011_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_011_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_011_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-badge>200.00.012</b-badge>
                                                Сумма взносов на обязательное социальное медицинское страхование
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="1 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_012_1"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="2 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_012_2"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="3 месяц">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_012_3"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-group label="ИТОГО ЗА КВАРТАЛ">
                                                    <b-form-input readonly type="number" size="sm"
                                                                  v-model="form.data.page_200_00_03.field_200_00_012_4"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </b-tab>


                            <b-tab title="Приложение 1">

                                <div class="tax-form">
                                    <h4>Исчисление ИПН и СН, ОПВ, ОППВ, СО и Отчислений (Взносов) на ОСМС</h4>

                                    <template v-if="typeof form.data.form_200_01 != 'undefined'">

                                        <div class="tax-form-section">
                                            <h5>Индивидуальный подоходный налог</h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.001</b-badge>
                                                    Начисленные доходы
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <b-form-group label="A. В том числе доходы работников">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_A"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-6">
                                                    <b-form-group label="E. доходы физических лиц по договорам ГПХ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_001_E"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.003</b-badge>
                                                    Сумма ИПН, исчисленного с начисленных доходов
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_003_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_003_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_003_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_003_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.007</b-badge>
                                                    Выплачено доходов
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_007_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_007_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_007_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_007_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.008</b-badge>
                                                    Облагаемый доход
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_008_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_008_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_008_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_008_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="tax-form-section">
                                            <h5>ОПВ, ОППВ</h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.009</b-badge>
                                                    Начисленные доходы, с которых удерживаются (начисляются) обязательные
                                                    пенсионные взносы
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_009_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_009_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_009_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_009_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.010</b-badge>
                                                    Начисленные доходы, с которых исчисляются (начисляются) обязательные
                                                    профессиональные пенсионные взносы
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_010_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_010_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_010_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_01.field_200_01_010_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.012</b-badge>
                                                    Заявляемый доход в свою пользу
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_012_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_012_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_012_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_012_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="tax-form-section">
                                            <h5>Численность и расходы по оплате труда работников-инвалидов</h5>

                                            <div class="row">
                                                <div class="col-md-3">
                                                    <b-badge>200.01.013</b-badge>
                                                    Численность работников инвалидов
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_013_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_013_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_013_3"></b-form-input>
                                                    </b-form-group>
                                                </div>

                                            </div>

                                        </div>

                                        <div class="tax-form-section">
                                            <h5>Социальный налог с применением ставок, установленных пунктом 1 статьи 485
                                                Налогового кодекса</h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.016</b-badge>
                                                    Доходы работника, облагаемые социальным налогом
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_016_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_016_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_016_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_016_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="tax-form-section">
                                            <h5>Социальные отчисления</h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.017</b-badge>
                                                    Доходы физических лиц, с которых исчисляются социальные отчисления
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_017_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_017_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_017_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_017_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.018</b-badge>
                                                    Доход, с которого исчисляются социальные отчисления в свою пользу
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_018_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_018_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_018_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_018_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="tax-form-section">
                                            <h5>Отчисления и (или) взносы на обязательное социальное медицинское
                                                страхование</h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.019</b-badge>
                                                    Доходы, с которых исчисляются отчисления на обязательное социальное
                                                    медицинское страхование
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_019_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_019_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_019_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_019_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <b-badge>200.01.020</b-badge>
                                                    Доходы, с которых исчисляются взносы на обязательное социальное
                                                    медицинское страхование
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="I. 1 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_020_1"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="II. 2 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_020_2"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="III. 3 месяц">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_020_3"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-group label="IV. ИТОГО ЗА КВАРТАЛ">
                                                        <b-form-input readonly type="number" size="sm"
                                                                      v-model="form.data.form_200_01.page_200_01_02.field_200_01_020_4"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                            </div>


                                        </div>

                                    </template>

                                </div>


                            </b-tab>


                            <b-tab title="Приложение 2">
                                <h4>Исчисление индивидуального подоходного налога с доходов иностранцев и лиц без
                                    гражданства</h4>
                                <table class="table table-sm table-striped table-hover table-bordered table-responsive"
                                       v-if="typeof form.data.form_200_02 != 'undefined'">
                                    <tbody>


                                    <tr>
                                        <th style="min-width: 5rem;">A. №</th>
                                        <th style="min-width: 15rem;">B. Фамилия, имя, отчество иностранца или лица без
                                            гражданства
                                        </th>
                                        <th style="min-width: 10rem;">C. ИИН иностранца или лица без гражданства</th>
                                        <th style="min-width: 8rem;">D. Признак резиденства</th>
                                        <th style="min-width: 8rem;">E. Код страны резиденства</th>
                                        <th style="min-width: 8rem;">F. Номер налоговой регистрации</th>
                                        <th style="min-width: 20rem;" colspan="3">G. Вид, номер и дата выдачи документа,
                                            удостоверяющего личность иностранца или лица без гражданства
                                        </th>
                                        <th style="min-width: 8rem;">H. Код вида дохода</th>
                                        <th style="min-width: 8rem;">I. Вид международного договора</th>
                                        <th style="min-width: 8rem;">J. Наименование международного договора</th>
                                        <th style="min-width: 8rem;">K. Код страны, с которой заключен международный
                                            договор
                                        </th>
                                        <th style="min-width: 8rem;">L. Является работником участника или органа МФЦА</th>
                                        <th style="min-width: 8rem;">M. Является лицом структурного подразделения</th>
                                        <th style="min-width: 8rem;">N. Ставка налога</th>
                                        <th style="min-width: 8rem;">O. Начислено доходов</th>
                                        <th style="min-width: 8rem;">P. Доходы, не подлежащие налогооблажению</th>
                                        <th style="min-width: 8rem;">Q. Обязательные пенсионные взносы</th>
                                        <th style="min-width: 8rem;">R. Сумма взносов на ОСМС</th>
                                        <th style="min-width: 8rem;">S. Стандартные налоговые вычеты</th>
                                        <th style="min-width: 8rem;">T. Добровольные пенсионные взносы</th>
                                        <th style="min-width: 8rem;">U. Оплата медицинских услуг (кроме косметологических)
                                        </th>
                                        <th style="min-width: 8rem;">V. Суммы, направленные на погашение вознаграждения по
                                            жилищным займам
                                        </th>
                                        <th style="min-width: 8rem;">W. Облагаемый доход</th>
                                        <th style="min-width: 8rem;">X. Индивидуальный подоходный налог</th>
                                        <th style="min-width: 8rem;">Y. Выплачено доходов</th>
                                        <th style="min-width: 8rem;">Z. Индивидуальный подоходный налог, подлежащий уплате в
                                            бюджет
                                        </th>
                                        <th style="min-width: 8rem;">AA. Выплаты, не облагаемые социальным налогом, за
                                            исключением ОПВ
                                        </th>
                                        <th style="min-width: 8rem;">AB. Выплаты, облагаемые социальным налогом</th>
                                        <th style="min-width: 8rem;">AC. Социальный налог</th>
                                        <th style="min-width: 8rem;">AD. Расходы работодателя, с которых исчисляются
                                            социальные отчисления
                                        </th>
                                        <th style="min-width: 8rem;">AE. Сумма социальных отчислений</th>
                                        <th style="min-width: 8rem;">AF. Обязательные профессиональные пенсионные взносы
                                        </th>
                                        <th style="min-width: 8rem;">AG. Обязательные пенсионные взносы работодателя</th>
                                        <th style="min-width: 8rem;">AI. Сумма отчислений на ОСМС</th>
                                    </tr>


                                    <template v-if="typeof form.data.form_200_02.rows != 'undefined'">
                                        <tr>
                                            <td>
                                                <b-form-input readonly type="text" size="sm" value="000001"></b-form-input>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_O')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_P')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_Q')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_R')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_S')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_T')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_U')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_V')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_W')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_X')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_Y')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_Z')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AA')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AB')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AC')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AD')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AE')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AF')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AG')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_02', 'field_200_02_AI')"
                                                ></b-form-input>
                                            </td>
                                        </tr>
                                    </template>

                                    <tr v-for="(item, itemObjKey) in form.data.form_200_02.rows" :key="item.counter">
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_A"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_B"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_C"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_D"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_E"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_F"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_G_1"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_G_2"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_G_3"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_H"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_I"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_J"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_K"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_L"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_M"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_N"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_O"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_P"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_Q"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_R"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_S"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_T"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_U"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_V"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_W"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_X"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_Y"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_Z"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AA"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AB"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AC"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AD"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AE"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AF"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AG"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input readonly type="text" size="sm"
                                                          v-model="form.data.form_200_02.rows[itemObjKey].field_200_02_AI"></b-form-input>
                                        </td>

                                    </tr>
                                    </tbody>
                                </table>

                            </b-tab>


                            <b-tab title="Приложение 3">
                                <p>Заполняется вручную</p>
                            </b-tab>


                            <b-tab title="Приложение 4">
                                <p>Заполняется вручную</p>
                            </b-tab>


                            <b-tab title="Приложение 5">

                                <h4>Исчисление налогов и социальных платежей с доходов физических лиц</h4>
                                <table class="table table-sm table-striped table-hover table-bordered table-responsive"
                                       v-if="typeof form.data.form_200_05 != 'undefined'">
                                    <tbody>
                                    <tr>
                                        <th style="min-width: 5rem;">A. №</th>
                                        <th style="min-width: 15rem;">B.Фамилия, имя, отчество</th>
                                        <th style="min-width: 10rem;">C. ИИН</th>
                                        <th style="min-width: 8rem;">D. Статус</th>
                                        <th style="min-width: 8rem;">E. Категория</th>
                                        <th style="min-width: 8rem;">F. Стр.подр.</th>
                                        <th style="min-width: 8rem;">G. Начислено доходов</th>
                                        <th style="min-width: 8rem;">H. Корректировка</th>
                                        <th style="min-width: 8rem;">I. ОПВ</th>
                                        <th style="min-width: 8rem;">J. ВОСМС</th>
                                        <th style="min-width: 8rem;">K. Ст. вычеты</th>
                                        <th style="min-width: 8rem;">L. Проч. вычеты</th>
                                        <th style="min-width: 8rem;">M. Облагаемый доход</th>
                                        <th style="min-width: 8rem;">N. Исчисленный ИПН</th>
                                        <th style="min-width: 8rem;">O. Выплачено доходов</th>
                                        <th style="min-width: 8rem;">P. ИПН в бюджет</th>
                                        <th style="min-width: 8rem;">Q. СН</th>
                                        <th style="min-width: 8rem;">R. СО</th>
                                        <th style="min-width: 8rem;">S. ОППВ</th>
                                        <th style="min-width: 8rem;">T. ОПВ работодателя</th>
                                        <th style="min-width: 8rem;">U. ООСМС</th>
                                    </tr>

                                    <template v-if="typeof form.data.form_200_05.rows != 'undefined'">
                                        <tr>
                                            <td>
                                                <b-form-input readonly type="text" size="sm" value="000001"></b-form-input>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_G')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_H')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_I')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_J')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_K')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_L')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_M')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_N')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_O')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_P')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_Q')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_R')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_S')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_T')"
                                                ></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              :value="getAmount('form_200_05', 'field_200_05_U')"
                                                ></b-form-input>
                                            </td>
                                        </tr>
                                        <tr v-for="(item, itemObjKey) in form.data.form_200_05.rows" :key="item.counter">
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_A"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_B"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="text" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_C"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_D"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_E"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_F"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_G"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_H"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_I"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_J"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_K"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_L"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_M"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_N"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_O"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_P"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_Q"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_R"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_S"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_T"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input readonly type="number" size="sm"
                                                              v-model="form.data.form_200_05.rows[itemObjKey].field_200_05_U"></b-form-input>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </div>


        <Premium v-else />

    </div>


</template>

<script>
import Enums from "@/components/base/Enums"
import Control from "@/components/base/ControlPanel"
import SelectOrg from "@/components/base/SelectOrg";
import {mapGetters} from "vuex";
import Premium from "@/components/base/Premium.vue";

export default {
    name: 'Form200',
    components: {
        Premium,
        Enums, Control, SelectOrg
    },
    data: function () {
        return {
            link: '',
          excel: {
            pril2: {
              fields: {
                'A. №': 'field_200_02_A',
                'B. Фамилия, имя, отчество иностранца или лица без гражданства': 'field_200_02_B',
                'C. ИИН иностранца или лица без гражданства': 'field_200_02_C',
                'D. Признак резиденства': 'field_200_02_D',
                'E. Код страны резиденства': 'field_200_02_E',
                'F. Номер налоговой регистрации': 'field_200_02_F',
                'G. Вид, номер и дата выдачи документа удостоверяющего личность иностранца или лица без гражданства': 'field_200_02_G',
                'H. Код вида дохода': 'field_200_02_H',
                'I. Вид международного договора': 'field_200_02_I',
                'J. Наименование международного договора': 'field_200_02_J',
                'K. Код страны, с которой заключен международный договор': 'field_200_02_K',
                'L. Является работником участника или органа МФЦА': 'field_200_02_L',
                'M. Является лицом структурного подразделения': 'field_200_02_M',
                'N. Ставка налога': 'field_200_02_N',
                'O. Начислено доходов': 'field_200_02_O',
                'P. Доходы, не подлежащие налогооблажению': 'field_200_02_P',
                'Q. Обязательные пенсионные взносы': 'field_200_02_Q',
                'R. Сумма взносов на ОСМС': 'field_200_02_R',
                'S. Стандартные налоговые вычеты': 'field_200_02_S',
                'T. Добровольные пенсионные взносы': 'field_200_02_T',
                'U. Оплата медицинских услуг (кроме косметологических)': 'field_200_02_U',
                'V. Суммы, направленные на погашение вознаграждения по жилищным займам': 'field_200_02_V',
                'W. Облагаемый доход': 'field_200_02_W',
                'X. Индивидуальный подоходный налог': 'field_200_02_X',
                'Y. Выплачено доходов': 'field_200_02_Y',
                'Z. Индивидуальный подоходный налог, подлежащий уплате в бюджет': 'field_200_02_Z',
                'AA. Выплаты, не облагаемые социальным налогом, за исключением ОПВ': 'field_200_02_AA',
                'AB. Выплаты, облагаемые социальным налогом': 'field_200_02_AB',
                'AC. Социальный налог': 'field_200_02_AC',
                'AD. Расходы работодателя, с которых исчисляются социальные отчисления': 'field_200_02_AD',
                'AE. Сумма социальных отчислений': 'field_200_02_AE',
                'AF. Обязательные профессиональные пенсионные взносы': 'field_200_02_AF',
                'AG. Обязательные пенсионные взносы работодателя': 'field_200_02_AG',
                'AI. Сумма отчислений на ОСМС': 'field_200_02_AI'
              }
            },
            pril5: {
              fields: {
                'A. №': 'field_200_05_A',
                'B.Фамилия, имя, отчество': 'field_200_05_B',
                'C. ИИН': 'field_200_05_C',
                'D. Статус': 'field_200_05_D',
                'E. Категория': 'field_200_05_E',
                'F. Стр.подр': 'field_200_05_F',
                'G. Начислено доходов': 'field_200_05_G',
                'H. Корректировка': 'field_200_05_H',
                'I. ОПВ': 'field_200_05_I',
                'J. ВОСМС': 'field_200_05_J',
                'K. Ст. вычеты': 'field_200_05_K',
                'L. Проч. вычеты': 'field_200_05_L',
                'M. Облагаемый доход': 'field_200_05_M',
                'N. Исчисленный ИПН': 'field_200_05_N',
                'O. Выплачено доходов': 'field_200_05_O',
                'P. ИПН в бюджет': 'field_200_05_P',
                'Q. СН': 'field_200_05_Q',
                'R. СО': 'field_200_05_R',
                'S. ОППВ': 'field_200_05_S',
                'T. ОПВ работодателя': 'field_200_05_T',
                'U. ООСМС': 'field_200_05_U'
              }
            }
          }
        }
    },
    methods: {
        getDataForm200: function () {
            this.$http
                .post(this.$apiold, {
                    task: 'form-200',
                    quarter: this.form.quarter,
                    year: this.form.year,
                    orgid: this.org.id
                })
                .then(response => {
                    //if (!response.data.error) {
                    this.$store.commit('formData200', response.data.form);
                  this.$store.commit('user', response.data.user);
                    //}

                    if (!response.data.error) {
                        this.getDataForm200XML();
                    }
                    // Сообщения
                    this.$store.commit('alert', response.data.messages);
                });
        },
        getDataForm200XML: function () {
            this.$http
                .post(this.$apiold, {
                    task: 'form-200-xml',
                    data: this.form.data
                })
                .then(response => {
                    this.link = response.data.link;
                })

        },
        clearLink: function () {
            this.link = '';
        },
        getAmount: function (form, field) {
            var counter = 0;
            var f = 0;
            if (typeof this.form.data[form].rows != 'undefined') {
                for (var i = 0; i < this.form.data[form].rows.length; i++) {
                    if (this.form.data[form].rows[i][field] == '') {
                        f = 0;
                    } else {
                        f = this.form.data[form].rows[i][field];
                    }
                    counter += parseInt(f);
                }
            }

            return counter;
        }
    },
    computed: {
      ...mapGetters({
          user: 'user',
        org: 'org',
        form: 'form200'
      })
    }
}
</script>

<style>
</style>